<template>
	<FormKit
		ref="app-autocomplete"
		type="autocomplete"
		popover
		selection-removable
		select-icon="down"
		selected-icon=""
		close-icon="close"
		open-on-remove
		selection-appearance="option"
		:options
		:option-loader
		:input-class="{ hasIcon: 'pl-9!' }"
		@focus="isFocused = true"
		@blur="isFocused = false"
	>
		<template #label="{ id, label }">
			<label :for="id"> {{ label }} </label>
			<hr />
		</template>
		<template v-if="hasIcon" #prefix="{ value, option }">
			<div
				v-if="value && option.icon && !isFocused"
				class="absolute top-1/2 -translate-y-1/2 w-5 h-auto left-[0.5rem] pointer-events-none"
			>
				<img
					:src="`/logos/${option.icon}`"
					:alt="option.label + ' logo'"
					class="object-contain"
				/>
			</div>
		</template>
		<template #option="{ option, classes }">
			<div
				:class="[
					`${classes.option} relative flex gap-2`,
					hasIcon ? 'pl-7' : '',
				]"
			>
				<img
					v-if="hasIcon && option.icon"
					:src="`/logos/${option.icon}`"
					:alt="option.label + ' logo'"
					class="absolute top-1/2 left-0 -translate-y-1/2 w-5 h-auto object-contain"
					onerror="this.classList.add(&quot;hidden&quot;);"
				/>
				<span class="cursor-default text-[0.85rem]">
					{{ option.label }}
				</span>
			</div>
		</template>
	</FormKit>
</template>

<script setup lang="ts">
import { nextTick, ref, useTemplateRef, watch } from "vue";
import type { useInput } from "@formkit/vue";

// Hack to get the `FormKitNode` type, since it's not exported.
type FormKitNode = ReturnType<typeof useInput>;

const props = defineProps<{
	options: { label: string; value: string; icon?: string }[];
	optionLoader?: (search: string) =>
		| {
				label: string;
				value: string;
				icon?: string;
		  }
		| undefined;
	hasIcon: boolean;
	autofocus?: boolean;
}>();

const isFocused = ref(false);

const selectLenderInput = useTemplateRef("app-autocomplete");
watch(
	selectLenderInput,
	(appAutocomplete) => {
		if (!appAutocomplete || !props.autofocus) {
			return;
		}

		void nextTick(() => {
			const id = ((appAutocomplete as any).node as FormKitNode)?.context?.id;
			if (!id) {
				return;
			}

			const inputEl = document.getElementById(id);
			inputEl?.focus();
		});
	},
	{ immediate: true },
);
</script>

<style scoped lang="scss">
hr {
	display: none;
}

.value-row hr {
	display: block;
}
</style>
